<template>
  <div>
    <div class="BackPlanMonitor-title">
      <div>{{ $t("alarms.backPlan.backPlan") }}</div>
      <div>
        <Button
          type="primary"
          @click="addOrUpdateHandle"
          v-hasPermission="['monitor:backPlanMonitor:add_alert_rule']"
          >{{ $t("alarms.backPlan.addBackPlanAlarm") }}</Button
        >
        <add-or-update-back-plan-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-back-plan-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" v-model="currentTab" :animated="false">
        <TabPane :label="$t('alarms.backPlan.backPlanList')">
          <div class="BackPlanMonitor-top">
            <back-plan-monitor-search></back-plan-monitor-search>
          </div>
          <table-back-plan
            @changeCurrentTab="changeCurrentTab"
          ></table-back-plan>
        </TabPane>
        <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
          <div>
            <back-plan-monitor-alert-rule-search></back-plan-monitor-alert-rule-search>
          </div>
          <table-back-plan-warning></table-back-plan-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import TableBackPlan from "../backPlan/TableBackPlan";
import BackPlanMonitorSearch from "../backPlan/BackPlanMonitorSearch";
import AddOrUpdateBackPlanWarning from "../backPlan/AddOrUpdateBackPlanWarning";
import LogWarningSearch from "../logs/log/LogWarningSearch";
import TableLogWarning from "../logs/log/TableLogWarning";
import TableBackPlanWarning from "./TableBackPlanWarning";
import BackPlanMonitorAlertRuleSearch from "./BackPlanMonitorAlertRuleSearch";

const tableBackPlanWarning = TableBackPlanWarning;
export default {
  name: "BackPlanMonitor",
  components: {
    TableBackPlanWarning,
    BackPlanMonitorSearch,
    BackPlanMonitorAlertRuleSearch,
    LogWarningSearch,
    TableLogWarning,
    TableBackPlan,
    AddOrUpdateBackPlanWarning
  },
  data() {
    return {
      currentTab: "",
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    changeCurrentTab: function(row, monitorIndex) {
      this.currentTab = "tabAlertRule";
      eventBus.$emit("instanceId", row.instanceId);
      eventBus.$emit("monitorIndex", monitorIndex);
      eventBus.$emit("typeId", 1);
      // eventBus.$emit('stateId', 0);
      tableBackPlanWarning.methods.showAll();
    }
  }
};
</script>

<style scoped>
.BackPlanMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.BackPlanMonitor-title > div:nth-child(1) {
  float: left;
}
.BackPlanMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.BackPlanMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/backPlan/BackPlanMonitor.vue